import {IBookingMutationWaiter} from "./booking-mutation-waiter.interface";

export class BookingMutationVoidWaiter implements IBookingMutationWaiter {
    readonly isMutationInProgress: boolean = false;

    waitForMutation(): Promise<void> {
        return Promise.resolve();
    }
}
